import EventsHandler from "../service/events";
import EVENTS from "../constants/events";
import {AnimationService} from "../service/animation";
import OpenDesktopNavigation from "../animations/open-desktop-navigation";
import CloseDesktopNavigation from "../animations/close-desktop-navigation";

export class LanguageSwitcherComponent {
    readonly $root: JQuery;
    private $header: JQuery;
    private $body: JQuery;
    private window: any;
    private events: EventsHandler;
    private animations: AnimationService;

    constructor(element: HTMLElement) {
        this.$body = $('body');
        this.$header = $('[data-elementor-type="header"]');
        this.window = $(<any>window);
        this.$root = $(element);
    }

    protected init() {
        this.events.addListener(EVENTS.LANGUAGE_SWITCHER_OPEN, this.handleLanguageSwitcherOpen);
        this.events.addListener(EVENTS.LANGUAGE_SWITCHER_CLOSE, this.handleLanguageSwitcherClose);
    }

    protected handleLanguageSwitcherOpen = () => {
        this.$body.addClass('is-nav-open');
        this.animations.run(OpenDesktopNavigation, this.$root);
        this.$body.on({mousedown: this.handleBodyClick});
    }

    protected handleLanguageSwitcherClose = () => {
        this.$body.removeClass('is-nav-open');
        this.animations.run(CloseDesktopNavigation, this.$root);
        this.$body.off({mousedown: this.handleBodyClick});
    }

    private handleBodyClick = (ev: MouseEvent) => {
        if ('true' === this.$root.attr('aria-expanded')) {
            if ($(ev.target).closest(this.$header).length === 0 && $(ev.target).closest(this.$root).length === 0) {
                this.events.emit(EVENTS.LANGUAGE_SWITCHER_CLOSE);
            }
        }
    }

    public setEventHandler(events: EventsHandler) {
        this.events = events;
        return this;
    }

    public setAnimationHandler(animations: AnimationService) {
        this.animations = animations;
        return this;
    }
}